import styled from 'styled-components'

export default styled.button`
  padding: 5px;
  background-color: ${(props) => props.theme.colors.grayLight};
  color: ${(props) => props.theme.clientColors.primary};
  font-size: 12pt;
  font-weight: 500;
  border-radius: 50%;
  text-decoration: none;
  align-items: center;
  justify-content: center;
  display: block;
  min-width: 35px;
  min-height: 35px;
  border: none;
  box-shadow: none;
  cursor: pointer;

  :hover,
  &.active {
    background-color: ${(props) => props.theme.clientColors.primary};
    color: ${(props) => props.theme.colors.grayLight};
  }

  &.highlighted:not(.active) {
    background-color: ${(props) => props.theme.colors.grayMedium};
    color: ${(props) => props.theme.clientColors.primary};
  }

  &:focus {
    outline: none;
  }

  &:disabled {
    color: ${(props) => props.theme.colors.grayMedium};
  }
`
